import React, { Component } from "react"
import { graphql } from "gatsby"
import AOS from 'aos'
import Layout from "../layouts"
import Marquee from 'react-marquee'
import $ from 'jquery';
import Lottie from 'react-lottie';
import { Helmet } from "react-helmet"

var lightBulbData = {"v":"5.6.1","fr":30,"ip":0,"op":47,"w":400,"h":400,"nm":"Bulb_Icon","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Bulb Body Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[199.41,191.736,0],"ix":2},"a":{"a":0,"k":[104.364,120.651,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[9.269,16.143],[0,15.366],[-43.75,0],[0,0],[0,-43.749],[7.126,-12.412],[0,-24.805],[0,0]],"o":[[0,0],[0,-24.805],[-7.126,-12.412],[0,-43.749],[0,0],[43.749,0],[0,15.366],[-9.269,16.143],[0,0],[0,0]],"v":[[-33.566,95.652],[-36.371,92.699],[-67.344,25.37],[-79.364,-16.437],[-0.149,-95.652],[0.149,-95.652],[79.364,-16.437],[67.344,25.37],[36.371,92.699],[33.565,95.652]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":12,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[104.364,120.652],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Bulb Reflection Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[173.88,149.055,0],"ix":2},"a":{"a":0,"k":[50.678,50.678,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-28.364,0]],"o":[[0,-28.364],[0,0]],"v":[[-25.678,25.678],[25.678,-25.678]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":27,"s":[0]},{"t":32,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[50.678,50.678],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Line 2 Outlines","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":14,"s":[2]},{"t":15,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":14,"s":[199.803,288.007,0],"to":[0,4.167,0],"ti":[0,-4.167,0]},{"t":18,"s":[199.803,313.007,0]}],"ix":2},"a":{"a":0,"k":[39.451,5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[5,5],[73.903,5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Line 1 Outlines","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":18,"s":[0]},{"t":19,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":18,"s":[199.803,317.781,0],"to":[0,3.167,0],"ti":[0,-3.167,0]},{"t":22,"s":[199.803,336.781,0]}],"ix":2},"a":{"a":0,"k":[39.451,5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[5,5],[73.903,5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Bulb Base Outlines","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":22,"s":[0]},{"t":25,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":22,"s":[199.606,350.091,0],"to":[0,3.333,0],"ti":[0,-3.333,0]},{"t":27,"s":[199.606,370.091,0]}],"ix":2},"a":{"a":0,"k":[27.775,12.082,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-15.202,0],[0,13.069],[0,0]],"o":[[15.202,0],[0,0],[0,13.069]],"v":[[0.001,11.832],[27.525,-11.832],[-27.525,-11.832]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[27.775,12.082],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Ray 1 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[103.339,272.82,0],"ix":2},"a":{"a":0,"k":[19.371,19.175,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[14.371,-14.174],[-14.371,14.174]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[19.371,19.175],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":36,"s":[0]},{"t":40,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Ray 2 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[63.376,175.521,0],"ix":2},"a":{"a":0,"k":[25.474,5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[45.948,5],[5,5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":36,"s":[0]},{"t":40,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Ray 3 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[102.946,78.514,0],"ix":2},"a":{"a":0,"k":[19.371,19.371,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[14.371,14.371],[-14.371,-14.371]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":36,"s":[0]},{"t":40,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[19.371,19.371],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Ray 4 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[199.606,38.551,0],"ix":2},"a":{"a":0,"k":[5,25.474,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[5,45.948],[5,5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":36,"s":[0]},{"t":40,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Ray 4 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[297.054,78.514,0],"ix":2},"a":{"a":0,"k":[19.371,19.371,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-14.371,14.371],[14.371,-14.371]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":36,"s":[0]},{"t":40,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[19.371,19.371],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Ray 5 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[336.624,175.521,0],"ix":2},"a":{"a":0,"k":[25.474,5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[5,5],[45.948,5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":36,"s":[0]},{"t":40,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Ray 6 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[296.661,272.82,0],"ix":2},"a":{"a":0,"k":[19.371,19.175,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-14.371,-14.174],[14.371,14.174]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":36,"s":[0]},{"t":40,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.941176470588,0.623529411765,0.329411764706,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[19.371,19.175],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":180,"st":0,"bm":0}],"markers":[]}

var loaded = false

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  document.getElementById("progress-bar").style.width = scrolled + "%";
}

function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}


class About extends Component {

  constructor(props) {
    super(props);

    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    AOS.init();

    window.onscroll = () => {
      myFunction();
      this.handleKeyPress();
      AOS.refresh();
    };

    window.onload = function (){
      AOS.refresh(); 
    }

    var video = document.getElementById("video");
	var pageContent = document.getElementById("excel-global-header-inner");
  	console.log('video????')
  	if (!pageContent.classList.contains('mobile')){

	  	if(video !== null){
			if ( video.readyState === 4 ) {
				console.log('video 4')
				video.play();
				video.classList.add('playing');
				video.setAttribute('aria-label', 'Playing. Click enter to pause');
			}else{
				console.log('video 4 nested')
			    var intervalId2 = setInterval(function(){
					
					if ( video.readyState === 4 ) {
						
					    clearInterval(intervalId2);
					    video.play();
					    video.classList.add('playing');
					    video.setAttribute('aria-label', 'Playing. Click enter to pause');
					    clearInterval(intervalId2);
					}else{
						console.log('video 4 nested?')
						console.log(video.readyState)
						// clearInterval(intervalId2);
					}
				}, 1000);
			}
		}else{
			console.log('video')
			var intervalId = setInterval(function(){
				video = document.getElementById("video");
				if(video !== null){
					if ( video.readyState === 4 ) {
						video.play();
						video.classList.add('playing');
						video.setAttribute('aria-label', 'Playing. Click enter to pause');
					    clearInterval(intervalId);
					}
				}else{
					// clearInterval(intervalId);
				}
			}, 1000);
			
		}
	}


  }

  componentWillReceiveProps(){ 
    AOS.refresh(); 
  }

  playVideo(){
  	let video = document.getElementById('video');
    video.play();
    video.classList.remove('paused');
    video.classList.add('playing');
    video.setAttribute('aria-label', 'Playing. Click enter to pause');
  }

  pauseplay(){
  	let video = document.getElementById('video');
    if (video.paused) {
        video.play();
        video.classList.remove('paused');
        video.classList.add('playing');
        video.setAttribute('aria-label', 'Playing. Click enter to pause');
    } else {
       	video.pause();
        video.classList.remove('playing');
        video.setAttribute('aria-label', 'Paused. Click enter to play');
        video.classList.add('paused');
    }

    return false;
  }
  pauseplayKeyPress(e){
  	var charCode = e.charCode || e.keyCode;
    if(charCode == 13) {
	  	let video = document.getElementById('video');
	    if (video.paused) {
	        video.play();
	        video.classList.remove('paused');
	        video.classList.add('playing');
	        video.setAttribute('aria-label', 'Playing. Click enter to pause');
	    } else {
	       	video.pause();
	        video.classList.remove('playing');
	        video.setAttribute('aria-label', 'Paused. Click enter to play');
	        video.classList.add('paused');
	    }

	    return false;
	}
  }

  openAccordion(e, i){

  	if(window.innerWidth > 768){

	    let activeElement = document.getElementById(`employeeDropDown_${i}`);

	    let bio = activeElement.getElementsByClassName( 'bio' )[0];

	    if (!activeElement.classList.contains('active')){
	      let height = activeElement.scrollHeight;
	      activeElement.classList.add("active");
	      activeElement.style.maxHeight = height + 'px';
	      let activeImage = document.getElementById(`employeeImage_${i}`);
	      activeImage.classList.remove("active");
	      bio.setAttribute('aria-hidden', 'false');
	      let infoRibbon = $(`#einforib_${i}`);
		  let offsetModule = infoRibbon.offset()
	      if(window.innerWidth > 768 && infoRibbon.offset().top - $(window).scrollTop() < 0){
	    	$('html,body').animate({
	    		scrollTop: offsetModule.top
	    	}, 300, 'linear',function () {
	    		AOS.init(); 
	    		AOS.refresh(); 
	    	});
	      }
	    }else{
	      let height = activeElement.scrollHeight;
    	  let infoRibbon = $(`#einforib_${i}`);
    	  let offsetModule = infoRibbon.offset()
		  setTimeout(function(){
			AOS.init(); 
			AOS.refresh(); 
		  }, 300);
	      activeElement.classList.remove("active");
	      activeElement.style.maxHeight = '0px';
	      bio.setAttribute('aria-hidden', 'true');

	    }
	}else{
		let activeElement = document.getElementById(`employeeDropDown_${i}`);

	    let bio = activeElement.getElementsByClassName( 'bio' )[0];
	    let arrow = document.getElementById(`arrow_${i}`);

	    if (!activeElement.classList.contains('active')){
	      let height = activeElement.scrollHeight;
	      activeElement.classList.add("active");
	      activeElement.style.maxHeight = height + 'px';
	      let activeImage = document.getElementById(`employeeImage_${i}`);
	      activeImage.classList.remove("active");
	      bio.setAttribute('aria-hidden', 'false');
	      arrow.classList.add("active");
	      
	    }else{
	      let height = activeElement.scrollHeight;
	      activeElement.classList.remove("active");
	      arrow.classList.remove("active");
	      activeElement.style.maxHeight = '0px';
	      bio.setAttribute('aria-hidden', 'true');

	    }
	}

  }

  openAccordionKeyPress(e, i){

    var charCode = e.charCode || e.keyCode;
    if(charCode == 13) {
      let activeElement = document.getElementById(`employeeDropDown_${i}`);

      let bio = activeElement.getElementsByClassName( 'bio' )[0];

      if (!activeElement.classList.contains('active')){
        let height = activeElement.scrollHeight;
        activeElement.classList.add("active");
        activeElement.style.maxHeight = height + 'px';
        let activeImage = document.getElementById(`employeeImage_${i}`);
        activeImage.classList.remove("active");
        bio.setAttribute('aria-hidden', 'false');
      
      }else{
        activeElement.classList.remove("active");
        activeElement.style.maxHeight = '0px';
        bio.setAttribute('aria-hidden', 'true');
      }
    }

  }

  hideImage(e, i){
    if (typeof window !== 'undefined' && window.innerWidth > 768){
      let activeImage = document.getElementById(`employeeImage_${i}`);
      let parentElement = document.getElementById(`employeeImage_${i}`).parentElement.parentElement;
      parentElement.classList.remove("active");
      activeImage.classList.remove("active");
      AOS.refresh(); 
    }
  }

  showImage(e, i){

    if (typeof window !== 'undefined' && window.innerWidth > 768){
      let activeImage = document.getElementById(`employeeImage_${i}`);
      let activeElement = document.getElementById(`employeeDropDown_${i}`);
      let parentElement = document.getElementById(`employeeImage_${i}`).parentElement.parentElement;

      if(!activeElement.classList.contains('active') && !activeImage.classList.contains('active')){
        activeImage.classList.add("active");
        parentElement.classList.add("active");
        console.log(parentElement)
      }else{
        activeImage.classList.remove("active");
        parentElement.classList.remove("active");
      }

      AOS.refresh(); 
    }
  }

  getAnchorStaggered300(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "300"
    }else{
      return "300"
    }
  }

  getAnchorStaggered600(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "600"
    }else{
      return "300"
    }
  }

  getAnchorStaggered450(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "450"
    }else{
      return "300"
    }
  }
  
  getAnchorStaggered900(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "900"
    }else{
      return "300"
    }
  }

  getAnchorStaggered1200(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "1200"
    }else{
      return "300"
    }
  }

  getAnchorStaggeredRowOne(){
    if (typeof window !== 'undefined' && window.innerWidth > 768){
      return ".staggered_row_one"
    }else{
      return ""
    }
  }

  getAnchorStaggeredRowTwo(){
    if (typeof window !== 'undefined' && window.innerWidth > 768){
      return ".staggered_row_two"
    }else{
      return ""
    }
  }

  renderMarquee(text, titleText, textByItem){
    if(typeof window !== 'undefined' && window.innerWidth > 768 ){
      return(
        <div data-aos="fade-up">
	        <div className="marquee">
		       	<div className="marquee__content" loop={true}>
		          {
		            textByItem.map((item, i) =>
		              <li key={"charity_item_" + i }>{item.name}
		              </li>
		            )
		          }
		          {
		            textByItem.map((item, i) =>
		              <li key={"charity_item_" + i }>{item.name}
		              </li>
		            )
		          }
		          {
		            textByItem.map((item, i) =>
		              <li key={"charity_item_" + i }>{item.name}
		              </li>
		            )
		          }
	          </div>
          	</div>
        </div>
      )
    }else{
      return(
        <ul className="charity_list" data-aos="fade-up">
          {
            textByItem.map((item, i) =>
              <li key={"charity_item_" + i }>
                —{item.name}
              </li>
            )
          }
          <li>And more.</li>
        </ul>
      )
    }
  }


  fadeRightvsUp(){
    if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "fade-right"
    }else{
      return "fade-up"
    }
  }

  handleKeyPress() {
    var elementToBaseScrollOffOf = document.getElementById("lightBulbWrapper");
    if(elementToBaseScrollOffOf !== null){
      var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      if(elementToBaseScrollOffOf.getBoundingClientRect().top - window.innerHeight + elementToBaseScrollOffOf.getBoundingClientRect().height/2 < 0){
       this[`lightBulbDataRef`].play()
      }
    }
  }

  render() {
    const data = this.props.data.allWordpressPage.edges[0].node

    let shuffledEmployees = shuffle(...[this.props.data.allWordpressWpEmployees.nodes])

    const metaData = this.props.data.allWordpressAcfOptions.group[0].edges[0].node.options.meta_data_by_page.about

    let employeesPostType = shuffledEmployees;

    let acfColor = '#F3A738';

    let text = '';
    let titleText = '';
    let textByItem;

    const rowLen =  data.acf.about.giving_back.charity_list.length;

    data.acf.about.giving_back.charity_list.map((elem, index) => {
      if (rowLen === index + 1) {
        titleText += elem.name
        text += elem.name + '          ';
      } else {
        titleText += elem.name + ", "
        text += elem.name + '           ';
      }
    })

    text = text + text + text + text + text + text + text
    textByItem = data.acf.about.giving_back.charity_list

    if (typeof window === 'undefined'){
      return (
        <Layout>
          <Helmet script={[{
              type: 'application/ld+json',
              innerHTML: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "WebPage",
                "url": "https://excelinstore.com/",
                "name": "Excel | Moving Retail Forward",
                "author": {
                    "@type": "Organization",
                    "name": "Excel",
                    "url": "https://excelinstore.com/",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "1021 International Drive",
                        "addressLocality": "Fergus Falls",
                        "addressRegion": "MN",
                        "postalCode": "56537",
                        "addressCountry": "USA"
                    },
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "contactType": "customer support",
                        "telephone": "+1-218-998-3800",
                        "email": "contact@excelinstore.com"
                    }
                },
                "description": "We guide clients through the creation of in-store visual merchandising displays and fixtures.",
                "publisher": {
                    "@type": "Organization",
                    "name": "Excel",
                    "url": "https://excelinstore.com/",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "1021 International Drive",
                        "addressLocality": "Fergus Falls",
                        "addressRegion": "MN",
                        "postalCode": "56537",
                        "addressCountry": "USA"
                    }
                }
              })
            }]}>
            <meta charSet="utf-8" />
            <html lang="en" />
            <title>Excel | About</title>
            <meta name="description" content={metaData.description} />
            <meta property="og:title" content={"Excel | About"}  />
            <meta property="og:type" content="WebSite" />
            <meta property="og:url" content="https://excelinstore.com/" />
            <meta property="og:image" content={metaData.image_data.url} />
            <meta property="og:image:type" content="image/jpeg" />
            <meta property="og:description" content={metaData.description} />
            <meta property="og:site_name" content="Excel Plastics" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={"Excel | About" } />
            <meta name="twitter:description" content={metaData.description} />
            <meta name="twitter:image" content={metaData.image_data.url} />
          </Helmet>
        </Layout>
        )
    }else{
   		var called = false
      window.addEventListener('mousedown', function() {
        if (called === false){
            let elem = document.getElementById('excel-global-header-inner')
            elem.classList.add('using-mouse');
            called = true
        }
      });

      return (
        <Layout>
          <Helmet script={[{
              type: 'application/ld+json',
              innerHTML: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "WebPage",
                "url": "https://excelinstore.com/",
                "name": "Excel | Moving Retail Forward",
                "author": {
                    "@type": "Organization",
                    "name": "Excel",
                    "url": "https://excelinstore.com/",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "1021 International Drive",
                        "addressLocality": "Fergus Falls",
                        "addressRegion": "MN",
                        "postalCode": "56537",
                        "addressCountry": "USA"
                    },
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "contactType": "customer support",
                        "telephone": "+1-218-998-3800",
                        "email": "contact@excelinstore.com"
                    }
                },
                "description": "We guide clients through the creation of in-store visual merchandising displays and fixtures.",
                "publisher": {
                    "@type": "Organization",
                    "name": "Excel",
                    "url": "https://excelinstore.com/",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "1021 International Drive",
                        "addressLocality": "Fergus Falls",
                        "addressRegion": "MN",
                        "postalCode": "56537",
                        "addressCountry": "USA"
                    }
                }
              })
            }]}>
            <meta charSet="utf-8" />
            <html lang="en" />
            <title>Excel | About</title>
            <meta name="description" content={metaData.description} />
            <meta property="og:title" content={"Excel | About"}  />
            <meta property="og:type" content="WebSite" />
            <meta property="og:url" content="https://excelinstore.com/" />
            <meta property="og:image" content={metaData.image_data.url} />
            <meta property="og:image:type" content="image/jpeg" />
            <meta property="og:description" content={metaData.description} />
            <meta property="og:site_name" content="Excel Plastics" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={"Excel | About" } />
            <meta name="twitter:description" content={metaData.description} />
            <meta name="twitter:image" content={metaData.image_data.url} />
          </Helmet>
          <div className="progress">
            <div id="progress-bar" style={{backgroundColor: acfColor}}></div>
          </div>
          <div className="hero--wrapper">
            <div className="hero long">
              <h1 className="micro" dangerouslySetInnerHTML={{__html: data.acf.about.hero.pre_intro}} data-aos="fade-up" data-aos-delay="400"/>
              <div className="title h2 longer"  data-aos="fade-up" data-aos-delay="800">{data.acf.about.hero.Intro}</div>
            </div>
          </div>
          { data.acf.about.hero.hero_images.length > 1 &&
            <div className="carousel--wrapper" data-aos="fade-up" data-aos-delay="1200">
              <div className="carousel">
                {  data.acf.about.hero.hero_images.map((elem, i) => (
                  <img src={elem.image.url} alt={elem.image.alt} key={"carousel_image_" + i} />
                ))}
              </div>
            </div>
          }
          { data.acf.about.hero.hero_images.length === 1 &&
            <div className="carousel--wrapper" data-aos="fade-up" data-aos-delay="1200" data-aos-anchor=".hero">
              <div className="carousel-fake">
                <img 
                  src={ data.acf.about.hero.hero_images[0].image.url} 
                  alt={ data.acf.about.hero.hero_images[0].image.alt} />
                
              </div>
            </div>
          }
          <div className="about-hero-additionals" data-aos="fade-up" data-aos-delay="1600" data-aos-anchor=".hero">
            <div className="content-wrapper-long">
              <h2 dangerouslySetInnerHTML={{__html: data.acf.about.hero.about_detail_header}} data-aos="fade-up"/>
              <div className="grid-wrapper">
                <div className="grid lap-one-third">
                  <div className="flag w" data-aos="draw-line">
                    <svg width="125px" height="10px" viewBox="0 0 125 10">
                      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="About---Desktop" transform="translate(-140.000000, -1460.000000)" fill="#FFFFFF">
                          <g id="Group" transform="translate(140.000000, 1460.000000)">
                            <polygon id="Rectangle-Copy-6" points="0 0 120.192308 0 125 5 120.192308 10 0 10 4.20673077 5"></polygon>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <div className="line">

                    </div>
                  </div>
                </div>
                <div className="grid lap-two-thirds">
                  <div className="body" dangerouslySetInnerHTML={{__html: data.acf.about.hero.about_detail_body}} data-aos="fade-up" data-aos-delay={this.getAnchorStaggered450()}/>
                </div>
              </div>
            </div>
          </div>
          <div className="staggered_grid cf">
            <div className="title">
              <div data-aos={this.fadeRightvsUp()}>Our Team</div>
            </div>
            <div className="staggered_row_one cf">
              <div className="image" data-aos="fade-up" data-aos-delay={this.getAnchorStaggered300()}>
                <img src={data.acf.about.our_team.staggered_row_one.image_left.url} alt={data.acf.about.our_team.staggered_row_one.image_left.alt} />
                <div data-aos="fade-up" data-aos-anchor={this.getAnchorStaggeredRowTwo()} data-aos-delay={this.getAnchorStaggered300()}>
                  <div className="icon about">
                   <div className="lottie-element" id="lightBulbWrapper">
                      <div className="inner">
                        <Lottie
                          ref={instance => (this[`lightBulbDataRef`] = instance)}
                          options={{
                            loop: false,
                            autoplay: false,
                            animationData: lightBulbData,
                            rendererSettings: {
                              preserveAspectRatio: 'xMidYMid slice'
                            }
                          }}
                        />
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="column-right">
                <div className="flag y" data-aos="draw-line">
                  <svg width="125px" height="10px" viewBox="0 0 125 10">
                    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="About---Desktop" transform="translate(-140.000000, -1460.000000)" fill="#FFFFFF">
                        <g id="Group" transform="translate(140.000000, 1460.000000)">
                          <polygon id="Rectangle-Copy-6" points="0 0 120.192308 0 125 5 120.192308 10 0 10 4.20673077 5"></polygon>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <div className="line"></div>
                </div>
                <div className="header" dangerouslySetInnerHTML={{__html: data.acf.about.our_team.staggered_row_one.header}} data-aos="fade-up" data-aos-delay={this.getAnchorStaggered300()} data-aos-anchor={this.getAnchorStaggeredRowOne()}/>
                <div className="body" dangerouslySetInnerHTML={{__html: data.acf.about.our_team.staggered_row_one.body}} data-aos="fade-up" data-aos-delay={this.getAnchorStaggered600()} data-aos-anchor={this.getAnchorStaggeredRowOne()} />
              </div>
            </div>
            <div className="staggered_row_two cf">
              <div className="body" dangerouslySetInnerHTML={{__html: data.acf.about.our_team.staggered_row_two.body}} data-aos="fade-up" data-aos-delay={this.getAnchorStaggered300()} data-aos-anchor={this.getAnchorStaggeredRowTwo()}>
              </div>
              <div className="image">
                <img src={data.acf.about.our_team.staggered_row_two.image.url} alt={data.acf.about.our_team.staggered_row_two.image.alt} data-aos="fade-up" data-aos-delay={this.getAnchorStaggered600()} data-aos-anchor={this.getAnchorStaggeredRowTwo()} />
              </div>
            </div>
          </div>
          <div className="employees-accordion">
            <div className="content-wrapper-long">
              { employeesPostType.map((employee, index) => (
                <div className="accordion-wrapper" key={"employee_" + index } data-aos="fade-up">

                  { employee.acf.employee.linkedin !== "" &&
                    <a href={employee.acf.employee.linkedin} className="employee__linkedin non-mobile" target="_blank">
                      <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1">
                        <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="About---Desktop" transform="translate(-1261.000000, -5741.000000)" fill="#0B1C3E">
                            <path d="M1266.50927,5760.59063 L1269.47618,5760.59063 L1269.47618,5751.08751 L1266.50927,5751.08751 L1266.50927,5760.59063 Z M1277.08927,5750.8108 C1277.28506,5750.8118 1277.48486,5750.82079 1277.75458,5750.83777 C1279.06421,5750.91868 1280.5227,5751.94162 1280.56565,5754.33913 C1280.60062,5756.31407 1280.59063,5759.44282 1280.59063,5760.59562 L1277.61372,5760.59562 C1277.61372,5759.41685 1277.62671,5756.98138 1277.62671,5755.25917 C1277.62671,5754.47598 1277.27507,5753.42208 1276.02238,5753.42208 C1274.64181,5753.42208 1274.30616,5754.70375 1274.30616,5755.25917 C1274.30616,5756.91345 1274.29218,5759.54671 1274.29218,5760.59562 L1271.33325,5760.59562 C1271.33325,5758.82846 1271.35123,5752.76277 1271.35123,5751.05055 C1272.87965,5751.05055 1273.61088,5751.04655 1274.1703,5751.04655 C1274.1703,5751.60797 1274.16531,5751.98358 1274.16531,5752.39215 C1274.63182,5751.44913 1275.9075,5750.85975 1276.45293,5750.83078 C1276.70167,5750.81879 1276.89347,5750.8098 1277.08927,5750.8108 Z M1267.99473,5746.2885 C1268.95473,5746.2885 1269.73092,5747.06569 1269.73092,5748.02469 C1269.73092,5748.9847 1268.95473,5749.76289 1267.99473,5749.76289 C1267.03572,5749.76289 1266.25953,5748.9847 1266.25953,5748.02469 C1266.25953,5747.06569 1267.03572,5746.2885 1267.99473,5746.2885 Z M1263.4994,5741 C1262.11484,5741 1261,5742.11484 1261,5743.4994 L1261,5763.4996 C1261,5764.88516 1262.11484,5766 1263.4994,5766 L1283.4996,5766 C1284.88516,5766 1286,5764.88516 1286,5763.4996 L1286,5743.4994 C1286,5742.11484 1284.88516,5741 1283.4996,5741 L1263.4994,5741 Z" id="Fill-1-Copy-27"></path>
                          </g>
                        </g>
                      </svg>
                    </a>
                  }
                  { window.innerWidth > 768 &&
	                  <div tabIndex="0" className="employee-info-ribbon cf" id={"einforib_" + index } onClick={(e) => this.openAccordion(e, index)} onKeyPress={(e) => this.openAccordionKeyPress(e, index)}>
	                  	<div className="desktop additional-info cf" id={"employeeDropDown_" + index } style={{'maxHeight':'0px'}}>
		                    <img src={employee.acf.employee.image.url} className="hidden-on-mobile"/>
		                    <div className="bio" dangerouslySetInnerHTML={{__html: employee.acf.employee.bio}} aria-hidden="true"/>
		                </div>
	                    <div className="floating-image" id={"employeeImage_" + index } aria-hidden="true">
	                      <img src={employee.acf.employee.image.url} />
	                    </div>
	                    <div className="employee__name" onMouseEnter={(e) => this.showImage(e, index)} onMouseLeave={(e) => this.hideImage(e, index)}>
	                      { employee.title }
	                    </div>
	                    { employee.acf.employee.linkedin !== "" &&
	                      <div className='employee__role a'>
	                        { employee.acf.employee.role }
	                      </div>
	                    }
	                    { employee.acf.employee.linkedin == "" &&
	                        <div className='employee__role ma'>
	                        { employee.acf.employee.role }
	                      </div>
	                    }
	                    <div className="mobile-only-employee-image" onClick={(e) => this.openAccordion(e, index)}>
		                  	{ employee.acf.employee.linkedin !== "" &&
			                    <a href={employee.acf.employee.linkedin} className="employee__linkedin mobile" target="_blank">
			                      <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1">
			                        <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			                          <g id="About---Desktop" transform="translate(-1261.000000, -5741.000000)" fill="#0B1C3E">
			                            <path d="M1266.50927,5760.59063 L1269.47618,5760.59063 L1269.47618,5751.08751 L1266.50927,5751.08751 L1266.50927,5760.59063 Z M1277.08927,5750.8108 C1277.28506,5750.8118 1277.48486,5750.82079 1277.75458,5750.83777 C1279.06421,5750.91868 1280.5227,5751.94162 1280.56565,5754.33913 C1280.60062,5756.31407 1280.59063,5759.44282 1280.59063,5760.59562 L1277.61372,5760.59562 C1277.61372,5759.41685 1277.62671,5756.98138 1277.62671,5755.25917 C1277.62671,5754.47598 1277.27507,5753.42208 1276.02238,5753.42208 C1274.64181,5753.42208 1274.30616,5754.70375 1274.30616,5755.25917 C1274.30616,5756.91345 1274.29218,5759.54671 1274.29218,5760.59562 L1271.33325,5760.59562 C1271.33325,5758.82846 1271.35123,5752.76277 1271.35123,5751.05055 C1272.87965,5751.05055 1273.61088,5751.04655 1274.1703,5751.04655 C1274.1703,5751.60797 1274.16531,5751.98358 1274.16531,5752.39215 C1274.63182,5751.44913 1275.9075,5750.85975 1276.45293,5750.83078 C1276.70167,5750.81879 1276.89347,5750.8098 1277.08927,5750.8108 Z M1267.99473,5746.2885 C1268.95473,5746.2885 1269.73092,5747.06569 1269.73092,5748.02469 C1269.73092,5748.9847 1268.95473,5749.76289 1267.99473,5749.76289 C1267.03572,5749.76289 1266.25953,5748.9847 1266.25953,5748.02469 C1266.25953,5747.06569 1267.03572,5746.2885 1267.99473,5746.2885 Z M1263.4994,5741 C1262.11484,5741 1261,5742.11484 1261,5743.4994 L1261,5763.4996 C1261,5764.88516 1262.11484,5766 1263.4994,5766 L1283.4996,5766 C1284.88516,5766 1286,5764.88516 1286,5763.4996 L1286,5743.4994 C1286,5742.11484 1284.88516,5741 1283.4996,5741 L1263.4994,5741 Z" id="Fill-1-Copy-27"></path>
			                          </g>
			                        </g>
			                      </svg>
			                    </a>
			                  }
		                    <img src={employee.acf.employee.image.url} />

		                </div>
		        
	                  </div>
	              }
	              { window.innerWidth < 769 &&
	              	<div tabIndex="0" className="employee-info-ribbon cf" id={"einforib_" + index } onClick={(e) => this.openAccordion(e, index)} onKeyPress={(e) => this.openAccordionKeyPress(e, index)}>
	                    <div className="floating-image" id={"employeeImage_" + index } aria-hidden="true">
	                      	<img src={employee.acf.employee.image.url} />
	                    </div>
	                    <div className="employee__name" onMouseEnter={(e) => this.showImage(e, index)} onMouseLeave={(e) => this.hideImage(e, index)}>
	                      { employee.title }
	                    </div>
	                    { employee.acf.employee.linkedin !== "" &&
	                      <div className='employee__role a'>
	                        { employee.acf.employee.role }
	                      </div>
	                    }
	                    { employee.acf.employee.linkedin == "" &&
	                        <div className='employee__role ma'>
	                        	{ employee.acf.employee.role }
	                      	</div>
	                    }
	                    <div className="mobile-only-employee-image">
		                  	{ employee.acf.employee.linkedin !== "" &&
			                    <a href={employee.acf.employee.linkedin} className="employee__linkedin mobile" target="_blank">
			                      <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1">
			                        <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			                          <g id="About---Desktop" transform="translate(-1261.000000, -5741.000000)" fill="#0B1C3E">
			                            <path d="M1266.50927,5760.59063 L1269.47618,5760.59063 L1269.47618,5751.08751 L1266.50927,5751.08751 L1266.50927,5760.59063 Z M1277.08927,5750.8108 C1277.28506,5750.8118 1277.48486,5750.82079 1277.75458,5750.83777 C1279.06421,5750.91868 1280.5227,5751.94162 1280.56565,5754.33913 C1280.60062,5756.31407 1280.59063,5759.44282 1280.59063,5760.59562 L1277.61372,5760.59562 C1277.61372,5759.41685 1277.62671,5756.98138 1277.62671,5755.25917 C1277.62671,5754.47598 1277.27507,5753.42208 1276.02238,5753.42208 C1274.64181,5753.42208 1274.30616,5754.70375 1274.30616,5755.25917 C1274.30616,5756.91345 1274.29218,5759.54671 1274.29218,5760.59562 L1271.33325,5760.59562 C1271.33325,5758.82846 1271.35123,5752.76277 1271.35123,5751.05055 C1272.87965,5751.05055 1273.61088,5751.04655 1274.1703,5751.04655 C1274.1703,5751.60797 1274.16531,5751.98358 1274.16531,5752.39215 C1274.63182,5751.44913 1275.9075,5750.85975 1276.45293,5750.83078 C1276.70167,5750.81879 1276.89347,5750.8098 1277.08927,5750.8108 Z M1267.99473,5746.2885 C1268.95473,5746.2885 1269.73092,5747.06569 1269.73092,5748.02469 C1269.73092,5748.9847 1268.95473,5749.76289 1267.99473,5749.76289 C1267.03572,5749.76289 1266.25953,5748.9847 1266.25953,5748.02469 C1266.25953,5747.06569 1267.03572,5746.2885 1267.99473,5746.2885 Z M1263.4994,5741 C1262.11484,5741 1261,5742.11484 1261,5743.4994 L1261,5763.4996 C1261,5764.88516 1262.11484,5766 1263.4994,5766 L1283.4996,5766 C1284.88516,5766 1286,5764.88516 1286,5763.4996 L1286,5743.4994 C1286,5742.11484 1284.88516,5741 1283.4996,5741 L1263.4994,5741 Z" id="Fill-1-Copy-27"></path>
			                          </g>
			                        </g>
			                      </svg>
			                    </a>
			                  }
		                    <img src={employee.acf.employee.image.url} />
	                  	</div>
	                  	<div className="arrow" id={"arrow_" + index } >
	                   		<span className="down"></span>
	                    	<span className="plus"></span>
	                  	</div>
	                  	<div className="mobile additional-info cf" id={"employeeDropDown_" + index } style={{'maxHeight':'0px'}}>
	                    	<img src={employee.acf.employee.image.url} className="hidden-on-mobile"/>
	                    	<div className="bio" dangerouslySetInnerHTML={{__html: employee.acf.employee.bio}} aria-hidden="true"/>
	                  	</div>
                  	</div>
	            }
                  
                </div>
              ))}
            </div>
          </div>
          <div className="our-story">
            <div className="reverse-flex-wrapper">
              { data.acf.about.our_story.video === "yes" &&
                <div className="video--outer" data-aos="fade-up">
                  <div className="video--inner">
					<video tabIndex="0" poster={data.acf.about.our_story.video_poster_url} className="video" src={data.acf.about.our_story.video_url} type="video/mp4" ref="vidRef" onClick={() => this.pauseplay()} onKeyPress={(e) => this.pauseplayKeyPress(e)} id="video" muted={true} loop={true}></video>
                  	<div class="play-button">
                  		<svg width="154px" height="154px" viewBox="0 0 154 154" version="1.1"><g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="University---Desktop" transform="translate(-643.000000, -3469.000000)"><g id="Group-Copy-4" transform="translate(645.000000, 3471.000000)"><g id="Group-18"><circle id="Oval" stroke="#FFFFFF" stroke-width="3" cx="75" cy="75" r="75"></circle><polygon id="Rectangle" fill="#FFFFFF" transform="translate(71.965805, 75.000000) rotate(-315.000000) translate(-71.965805, -75.000000) " points="57.9658053 69.1954583 85.9658053 61 77.7703471 89"></polygon></g></g></g></g></svg>
                  	</div>
                  	</div>
                </div>
              }
              <div className="hero-flag">
                <div className="title">
                  <div data-aos={this.fadeRightvsUp()}>Our Story</div>
                </div>
                <h2 className="header" data-aos="fade-up" dangerouslySetInnerHTML={{__html: data.acf.about.our_story.flag}}></h2>
              </div>
            </div>
            <div className="three-column-info cf">
              <div className="content-wrapper-long">
                <div className="line-wrapper">
                  <div className="flag y" data-aos="draw-line">
                    <svg width="125px" height="10px" viewBox="0 0 125 10">
                      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="About---Desktop" transform="translate(-140.000000, -1460.000000)" fill="#FFFFFF">
                          <g id="Group" transform="translate(140.000000, 1460.000000)">
                            <polygon id="Rectangle-Copy-6" points="0 0 120.192308 0 125 5 120.192308 10 0 10 4.20673077 5"></polygon>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
                <div className="bio" dangerouslySetInnerHTML={{__html: data.acf.about.our_story.body_one}} data-aos="fade-up" data-aos-delay="150"/>
                <div className="bio two" dangerouslySetInnerHTML={{__html: data.acf.about.our_story.body_two}} data-aos="fade-up" data-aos-delay="300"/>
              </div>
            </div>
          </div>
          <div className="givingback--callout">
            <div className="content-wrapper">
              <div className="title">
                <div data-aos={this.fadeRightvsUp()}>Giving Back</div>
              </div>
              <div className="grid-wrapper">
                <div className="grid">
                  <div className="header" data-aos="fade-up" dangerouslySetInnerHTML={{__html: data.acf.about.giving_back.header}} />
                  <div className="body" data-aos="fade-up" dangerouslySetInnerHTML={{__html: data.acf.about.giving_back.body}} />
                </div>
              </div>
            </div>
            {
              this.renderMarquee(text, titleText, textByItem)
            }
          </div>
        </Layout>
      )
  }
  }
}

export default About

// Set here the ID of the home page.
export const pageQuery = graphql`
  query {
    allWordpressAcfOptions {
      group(field: id) {
        edges {
          node {
            options {
              meta_data_by_page {
                about {
                  description
                  image_data {
                    alt
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
    allWordpressPage(filter: {template: {eq: "about.php"}}){
      edges {
        node {
          id
          title
          excerpt
          slug
          date(formatString: "MMMM DD, YYYY")
          acf {
            about {
              giving_back {
                body
                header
                charity_list {
                  name
                }
              }
              hero {
                Intro
                about_detail_body
                about_detail_header
                pre_intro
                hero_images {
                  image {
                    alt
                    url
                    title
                  }
                }
                hero_video
              }
              our_story {
                body_one
                body_two
                flag
                video
                video_url
                preview_image_video {
                  url
                  alt
                }
                video_poster_url
              }
              our_team {
                staggered_row_one {
                  animating_svg
                  header
                  body
                  image_left {
                    alt
                    url
                  }
                }
                staggered_row_two {
                  body
                  image {
                    url
                    alt
                  }
                }
              }
            }
          }
        }
      }
    }
    allWordpressWpEmployees {
      nodes {
        acf {
          employee {
            bio
            linkedin
            role
            image {
              url
              alt
            }
          }
        }
        title
      }
    }
    allWordpressWpBlog {
      edges {
        node {
          title
          slug
        }
      }
    }
  }
`
